module.exports = __webpack_public_path__ + "static/media/socialmarketW.286677f3.svg";